import { render } from "./ModalTransactionType.vue?vue&type=template&id=6dbdb9fa"
import script from "./ModalTransactionType.vue?vue&type=script&lang=js"
export * from "./ModalTransactionType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__